// extracted by mini-css-extract-plugin
export default {"container":"MainPage_container__Lm-lH","loadingContainer":"MainPage_loadingContainer__7XQhb","loadingText":"MainPage_loadingText__hRyer"};